import { createGlobalStyle} from "styled-components";

export const BrandedStyles = createGlobalStyle`
  $primary:${({ theme }) => theme["primary"]};
  $tertiary: ${({ theme }) => theme["tertiary"]};
  $secondary: ${({ theme }) => theme["secondary"]};
  $light: ${({ theme }) => theme["light"]};
  $dark: ${({ theme }) => theme["dark"]};
  $gray: ${({ theme }) => theme["gray"]};
  $app-bg-color: ${({ theme }) => theme["app-bg-color"]};
  $app-bg-image: ${({ theme }) => theme["app-bg-image"]};
  $app-bg-position: ${({ theme }) => theme["app-bg-position"]};
  $header-bg: ${({ theme }) => theme["header-bg"]};
  $lt-yellow: ${({ theme }) => theme["lt-yellow"]};

  $round-bg-sm: 40px;
  $round-bg-md: 80px;
  $round-bg-lg: 120px;
  $logo_width: 45%;
  $logo_height: auto;
  $bg-img: ${({ theme }) => theme["bg-img"]};

  // Fonts
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

  // General App styling
  * {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
  }

  *[color="tertiary"] {
    color:${({ theme }) => theme["tertiary"]};
    $:before {
      color:${({ theme }) => theme["tertiary"]};
    }
    $:after {
      color:${({ theme }) => theme["tertiary"]};
    }
  }

  hr {
    opacity: .125 !important;
  }

  .no-scroll{
    overflow: hidden;
  }

    .hide {
      display: none;
    }

    .toggle-header-icon {
      cursor: pointer;
    }

    .pagination-arrow {
      cursor:pointer;
    }

    .float-right{
      float: right !important;
    }

  .show-toggle-content{
    .optional-content{
      display: none;
    }

    .toggle-optional-content .col{
      visibility: hidden;
    }

    .toggle-optional-content:hover .col{
      visibility: visible;
    }
  }

.show-optional-content{
  .toggle-optional-content{
    display: none;
  }
}

.display-photos-container, .display-photos-container .container {
  max-width:100% !important;
}

.hover .hover-only {
  display:flex;
}

.no-hover .hover-only {
  display:none;
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

// Bootstrap Overrides

.container{ // This controls the top margin inside of the main containers
  margin-top: .5rem;
}

.navbar{
  padding-top: 0.05rem !important;
  padding-bottom: 0.05rem !important;
}

.navbar-brand{
  width: 25rem;
  padding-left: .5rem;
}

.modal{
  &-header{
    padding: .5rem 1rem;
  }
  .close{
    background-color: transparent;
    border: none;
    font-size: 2rem;
    padding: 0;
    margin: 0;
  }
  &-content {
    color:${({ theme }) => theme["primary"]} !important;
    border:2px solid ${({ theme }) => theme["primary"]} !important;
    max-width:96vw;
    margin:auto;
    background-color:rgba(0, 0, 0, .7);
    border:2px solid ${({ theme }) => theme["primary"]} !important;
  }
}

.no-header .modal-header{display:none;}
.no-footer .modal-footer{display:none;}

.modal-dialog {
  max-width:1350px !important;
}

  .full-screen {
    width:100% !important;
    height:100% !important;
  }

  .full-size-photo{
    max-width:100%;
    max-height:auto;
  }

.form-control{
  border-radius: .5rem !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

// Custom styles for controls
.tooltip{
  &--left-align{
    text-align: left;
  }
}

.list{
  padding-left: 0;
  list-style: none;
  &--py-small{
    padding-top: .5rem;
    padding-bottom: .5rem;
  }
  &--border-t{
    border-top: solid 1px #dfdfdf;
  }
  &--border-b{
    border-bottom: solid 1px #dfdfdf;
  }
}

.dropdown-menu{
  min-width: 20rem !important;
}
.dropdown-item{
  padding: .5rem 1rem !important;
}
.dropdown-menu button:active{
  background-color: transparent;
}

// Utilities
.img-fluid {
  max-height: auto;
  height: 100%;
}
.img-circle {
  border-radius: 50%;
}
.align-right{
  text-align: end;
}
.align-center{
  display: flex;
  align-items: center;
}
.justify-content{
  display: flex;
  &--center{
    align-items: center;
    justify-content: center;
  }
  &--center-top{
    align-items: baseline;
    justify-content: center;
  }
}
.justify-center{
  display: flex;
      justify-content: center !important;
  &-xs{
    @media screen and (max-width: 576px) {
      display: flex;
      justify-content: center !important;
    }
  }
  &-sm{
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: center !important;
    }
  }
  &-md{
    @media screen and (max-width: 960px) {
      display: flex;
      justify-content: center !important;
    }
  }
}
.centered-div{
  position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: row;
}
.cursor-pointer{
  cursor: pointer;
}
.align-end{
  text-align: end;
}
.scroll{
  &-x{
    width: 100%;
    // height: 135px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-left: .75rem;
    padding-top: .35rem;
  }
  .card{
    display: inline-block;
    width: 135px;
    margin-right: .5rem;
  }
}
.wrapper{
  width: 100%;
  height: 100px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.wrapper .item{
  display: inline-block;
  width: 150px;
}
.text-large{
  &-1{
    font-size: 1rem;
  }
  &-2{
    font-size: 2rem;
  }
  &-3{
    font-size: 3rem;
  }
  &-4{
    font-size: 4rem;
  }
  &-5{
    font-size: 5rem;
  }
}
.full-height{
  height: 100% !important;
}
.fixed-w-50{
  width: 50px;
}
.fixed-h-50{
  height: 50px;
}
.fixed-w-100{
  width: 100px;
}
.fixed-h-100{
  height: 100px;
}
.dashed-border{
  border: 1px dashed ${({ theme }) => theme["gray"]};;
}
.solid-border{
  border: 1px solid ${({ theme }) => theme["light"]};;
}
.m{
  &--sm-0{
    @media screen and (max-width: 576px) {
      margin: 0 !important;
    }
  }
  &--sm-1{
    @media screen and (max-width: 576px) {
      margin: 1rem !important;
    }
  }
  &--md-0{
    @media screen and (max-width: 760px) {
      margin: 0 !important;
    }
  }
  &--md-1{
    @media screen and (max-width: 760px) {
      margin: 1rem !important;
    }
  }
  &--lg-0{
    @media screen and (min-width: 761px) {
      margin: 0 !important;
    }
  }
  &--lg-1{
    @media screen and (min-width: 761px) {
      margin: 0 1rem !important;
    }
  }
}

.h-90{
  max-height: 90vh !important;
}

.w-90{
  max-width: 90vw !important;
}

.h-80{
  max-height: 80vh !important;
}

.w-80{
  max-width: 80vw !important;
}

.grid-photo{
  
}

.dashboard{
  h4{ 
    font-size: 22px !important;
  }
  .card{
    height: 100% !important;
    &-header{
      background: transparent;
      border-bottom: none;
    }
    &--logo{
      img{
        max-width: 90px;
        height: auto;
        padding-right: 1rem;
      }
    }
    &__description{
      text-align: left !important;
    }
    &__location{
      border: none;
      
      .card_logo{
        width:100%;
        max-width:100px;
      }
      .card-body{
        padding: .5rem 0;
        height: 55px;
      }
      .card-footer{
        background: transparent;
        border-top: none;
        padding: .25rem 0;
      }
      .address-1, .address-2, .address-city-state{
        font-size: .85rem !important;
        font-weight: 500;
      }
    }
    img{
      max-width: 200px;
      height: auto;
      @media screen and (max-width: 768px) {
        max-width: 185px;
        height: auto;
      }
      @media screen and (max-width: 576px) {
        max-width: 105px;
        height: auto;
      }
    }
    @media screen and (max-width: 768px) {
      h4{ 
        font-size: 20px !important;
      }
      .card{
        img{
          max-width: auto;
          max-height: 80px;
        }
      }
      
    }
  }
}

.upload-picture{
  img{
    max-width: 150px;
    height: auto;
  }
}

.md-icon {
  font-size:1.5rem;
}

.location{
  &-qr-img{
    width: 120px;
    height: 120px;
  }
  .card{
    .card_logo{
      width:100%;
      max-width:80px;
    }
    .card-body{
      padding: .5rem 0;
      height: 55px;
    }
    .card-footer{
      background: transparent;
      border-top: none;
      padding: .25rem 0;
    }
    .address-1, .address-2, .address-city-state{
      font-size: .85rem !important;
      font-weight: 500;
    }
  }
}

.location-icons {
  .location-icon{
    font-size:1.1rem;
  }
}
.location-header {
  min-height:5rem;
  margin-bottom: .5rem;

	.location-top-row {
    h1, h2, h3, h4, h5, h6{
      margin-bottom: 0;
    }
	}

	&__name {
    font-style:italic;
	}

	.location-detail-row {
    line-height: 80%;
	}

	.location-logo-container img {
    max-width: 100px;
    height: auto;
	}

	.location-address-container {
    font-size:.75rem;
    margin-left: 0;
    padding-left: 0; 
    @media screen and (max-width: 576px) {
      padding-left: .5rem;
    } 
	}

	.location-map-container {
    cursor: pointer;
  }
  
  .location-map-container .map-label{
    padding-left:.06125rem;
    text-transform: uppercase;
  }

	.map-icon {
    font-size:1.5rem;
	}

	.map-label {
    font-size:.7rem;
    font-weight:bold;
	}
}

.green-check {
  color:green;
}

.location-header .phone-number, .location.address{
  line-height: 1.25rem;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.location-header-logo {
  width:100%;
  max-width:100px;
  border-radius: 50%;
    padding: 1px;
    border: 2px solid rgb(215, 215, 215);
}

.back-stripe .back-link-container {
  background-color:#fff;
}

.cart-item > .row{
  margin: 1rem;
  background-color: #99999950;
  padding: 1rem;
  border-radius: .5rem;
}

.cart-item select{
  float: right;
  width:50%;
}
.cart-item label{
  float:left;
}
.cart-item .data-cell{
  margin-bottom:.5rem;
}

input[type="checkbox"] {
  transform:scale(2, 2);
}

.screen-blocker {
  width:100%;
  height: 100%;
  position: absolute;
  left:0;
  top:0;
  background-color: rgba(0, 0, 0, .9);

  &-text{
    text-align: center;
    padding:10%;
    color:#fff;
  }
}

.main-action-icon{
  color:#000 !important;
  float: right;
}

.half-width-container{
  max-width: 55rem !important;
}

.spin {  
  -webkit-animation:spin 3s linear infinite;
  -moz-animation:spin 3s linear infinite;
  animation:spin 3s linear infinite;
}

.spinner-border-lg {
  font-size:10rem;
}

.manual-email-entry{
  width: 100%;
  height: 75px;
  font-size: 1.25rem;
}

.photo-tile-fields {
  .col {
    text-align: left;
  }

  select {
    width:100%;
  }

  label {
    float:left;
  }

  .row{
    margin-bottom:.5rem;
  }
}

.layer-preview{
  width:auto;
  height:100px;
  border:1px solid #000;
  border-radius: .5rem;
}

.field-edit .react-colorful {
  margin:auto;
}

.m-a, .ma, .margin-auto, .m-auto {
  margin:auto;
}

@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

#root {    
  background-color:${({ theme }) => theme["app-bg-color"]};

.App {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    color: ${({ theme }) => theme["secondary"]};
    background: ${({ theme }) => theme["app-bg-color"] ? theme["app-bg-color"] : "inherit" };
    ${({ theme }) => theme["app-bg-img"] ? "background-image:url(" + theme["app-bg-img"] + ");" : ""}
    background-repeat:no-repeat;
    background-position:${({ theme }) => theme["app-bg-position"] ? theme["app-bg-position"] : "inherit"};

      h1, h2, h3, h4, h5, h6 {
      font-weight: 400;
      color:${({ theme }) => theme["primary"]} !important;
    }

  
    &__wrapper {
      display: flex;
      flex: 1 1;
      flex-direction: column;
      min-width: 0;
      min-height: 100vh;
    }
    &__wrapper:not(.App__wrapper-fluid) .App__header-fixed {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }
    &__wrapper:not(.App__wrapper-fluid) .c-body {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
    
    &__header.App__header-fixed {
      position: fixed;
      right: 0;
      left: 0;
      z-index: 1029;
    }
    &__header {
      background: ${({ theme }) => theme["header-bg"]};
      border-bottom: 2px solid ${({ theme }) => theme["primary"]};
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      flex-shrink: 0;
      min-height: 50px;
  
      &.see-through .toggle-header-icon, &:hover .hover-only {
        display: block;
        visibility:visible;
      }
  
      .hover-only {
        visibility: hidden;
      }
    }
    &__logo{
      width:${({ theme }) => theme["logo_width"]};
      height:${({ theme }) => theme["logo_height"]};
      height: auto;
      width:25vw;
      /*max-height: 15rem;*/
      @media screen and (max-width: 576px) {
        width: 100%;
      }
    }
    &__main {
      flex-basis: auto;
      flex-shrink: 0;
      flex-grow: 1;
      min-width: 0;
      // padding-top: .25rem;
      padding-bottom: .5rem;
      margin-bottom: 4.5rem;
      @media screen and (max-width: 576px) {
          margin-bottom: 6rem;
      }
    }
    &__advertising{
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 2 !important;
      &--banner-dsk{
        @media screen and (max-width: 576px) {
          display: none;
        }
        @media screen and (min-width: 551px) {
          display: block;
          img{
            width: 100%;
            height: auto;
          }
        }
      }
      &--banner-mob{
        @media screen and (max-width: 576px) {
          display: block;
          img{
            width: 100%;
            height: auto;
          }
        }
        @media screen and (min-width: 551px) {
          display: none;
        }
      }
    }
    &__footer{
      background-color: ${({ theme }) => theme["dark"]};
      color: ${({ theme }) => theme["light"]};
      padding: 1rem;
      text-align: center;
      a {
        color: ${({ theme }) => theme["tertiary"]};
        text-decoration: none;
      }
      a:hover{
        color: ${({ theme }) => theme["primary"]};
      }
    }
    &__overlay{
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.5);
      z-index: 1;
      width: 100%;
      height: 100%;
    }
  }
  .card.main-card {
    background-color:rgba(0, 0, 0, .75) !important;
    border-color: ${({ theme }) => theme["primary"]} !important;
  }
  .dropdown-menu button:hover{
    background-color: ${({ theme }) => theme["light"]};
  }
  
  .App__header.see-through {
    max-width:3.5rem;
    background-color:${({ theme }) => theme["primary"]};
    max-height: 3rem;
  }
  
  .display-photo-tile {
    img {
      width:100%;
      border:2px solid ${({ theme }) => theme["primary"]};
      margin:1rem;
      z-index:125;
      cursor: pointer;
    }
  
    .select-photo {
      float:right;
      margin-top:-2rem;
      margin-right:.75rem;
      z-index:152;
      position: relative;
    }
  }
  
  a{
    text-decoration: none !important;
    h1, h2, h3, h4, h5, h6{
      color: ${({ theme }) => theme["secondary"]} !important;
    }
  }
  
  // App Components
  .user{
    &__profile-pict-default{
      border: 3px solid ${({ theme }) => theme["gray"]};
      margin: 0 auto;
      padding: 3px;
      width: 80px;
      height: 80px;
    }
    &--secondary{
      background-color: ${({ theme }) => theme["secondary"]};
      color: white;
      font-size: 3rem;
    }
    &__profile-pict{
      border: 3px solid ${({ theme }) => theme["gray"]};
      margin: 0 auto;
      padding: 3px;
      height: auto;
      width:100%;
    }
  }
  
  .card{
    border-color: ${({ theme }) => theme["tertiary"]};
    border-radius: 8px !important;
    &-header{
      h1,h2,h3,h4,h5{
        margin-bottom: .1rem;
      }
    }
    &-header{
      background: transparent;
    }
    &-body{
      /*padding: auto .5rem;*/
    }
    &-text{
      /*padding: auto .5rem !important;*/
    }
    
    a {
      text-decoration: none;
    }
    &--bl{
      border-left: solid 2px ${({ theme }) => theme["primary"]} !important;
    }
  }
  
  .badge{
    padding-top: 5px !important;
    &__primary{
      background-color: ${({ theme }) => theme["primary"]};
    }
    &__secondary{
      background-color: ${({ theme }) => theme["secondary"]};
    }
    &__success{
      background-color: ${({ theme }) => theme["success"]};
    }
    &__danger{
      background-color: ${({ theme }) => theme["danger"]};
    }
    &__warning{
      background-color: ${({ theme }) => theme["warning"]};
    }
    &__info{
      background-color: ${({ theme }) => theme["info"]};
    }
    &__light{
      background-color: ${({ theme }) => theme["light"]};
    }
    &__dark{
      background-color: ${({ theme }) => theme["dark"]};
    }
    &--float-right{
      float: right;
    }
  }

  .text {
    &-dark {
      color: ${({ theme }) => theme["dark"]} !important;
    }
    &-light {
        color: ${({ theme }) => theme["light"]} !important;
    }
    &-warning {
        color: ${({ theme }) => theme["warning"]} !important;
    }
    &-primary {
        color: ${({ theme }) => theme["primary"]} !important;
    }
    &-secondary {
        color: ${({ theme }) => theme["secondary"]} !important;
    }
    &-gray {
        color: ${({ theme }) => theme["gray"]} !important;
    }
  }
  
  .btn{
    border-radius: .5rem !important;
    font-weight: 500 !important;
    padding: 10px 16px !important;
    &-success{
      background-color: ${({ theme }) => theme["primary"]} !important;
      border-color: ${({ theme }) => theme["primary"]} !important;
    }
    &-dark{
      background-color: ${({ theme }) => theme["dark"]} !important;
      border-color: ${({ theme }) => theme["dark"]} !important;
    }
    &--block{
      display: block;
      width: 100%;
    }
    &--small{
      padding: 3px 16px !important;
    }
    &-primary{
      background-color: ${({ theme }) => theme["primary"]} !important;
      border-color: ${({ theme }) => theme["primary"]} !important;
    }
    &-success{
      background-color: ${({ theme }) => theme["success"]} !important;
      border-color: ${({ theme }) => theme["success"]} !important;
    }
    &-info{
      background-color: ${({ theme }) => theme["info"]} !important;
      border-color: ${({ theme }) => theme["info"]} !important;
    }
    &-warning{
      background-color: ${({ theme }) => theme["warning"]} !important;
      border-color: ${({ theme }) => theme["warning"]} !important;
      i {
        color: #000;
      }
    }
    &-danger{
      background-color: ${({ theme }) => theme["danger"]} !important;
      border-color: ${({ theme }) => theme["danger"]} !important;
      i {
        color: #FFF;
      }
    }
  }
  .border-b{
    border-bottom: solid 1px darken(${({ theme }) => theme["light"]}, 8);
  }
  .round-bg{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    border-radius: 50%;
  
    &-primary{
      background-color: ${({ theme }) => theme["primary"]};
      color: white;
    }
    &-secondary{
      background-color: ${({ theme }) => theme["secondary"]};
      color: white;
    }
    &-success{
      background-color: ${({ theme }) => theme["success"]};
      color: white;
    }
    &-danger{
      background-color: ${({ theme }) => theme["danger"]};
      color: white;
    }
    &-warning{
      background-color: ${({ theme }) => theme["warning"]};
      color: white;
    }
    
    &--sm{
      width: $round-bg-sm !important;
      height: $round-bg-sm !important;
    }
    &--md{
      width: $round-bg-md !important;
      height: $round-bg-md !important;
    }
  }
  .focus-border{
    border: solid 3px darken(${({ theme }) => theme["light"]}, 5%) !important;
  }
  
  .pseudo-link {
    color:${({ theme }) => theme["primary"]};
    cursor: pointer;
    font-weight: bold;
  }
  
  .back-link-row {
    margin-bottom: .25rem;
  
    .back-link-container {
      cursor:pointer;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
    }
  
    .back-link-icon {
      line-height: 2.5rem !important;
    }
  
    .back-link-text {
      padding-left: .25rem;
      color:${({ theme }) => theme["primary"]};
      font-weight: 500;
    }
  }
  
  .warning-cell {
    background-color:${({ theme }) => theme["lt-yellow"]};
    padding:.5rem;
    font-style: italic;
  }
  
  .back-stripe {
    background-color:${({ theme }) => theme["secondary"]};
    width:100%;
    padding:.5rem;
  }
  
  .cart-item {
    color:${({ theme }) => theme["light"]};
  }
  
  .photo-status{
    text-align: center;
    margin-top:-1rem;
    color: ${({ theme }) => theme["primary"]};
    &-text{
      text-transform: capitalize;
      font-weight: bold;
      font-size-adjust: .7;
      &.denied{color:${({ theme }) => theme["danger"]};}
      &.approved{color:${({ theme }) => theme["success"]};}
    }
  }
}
`;